import {createApp} from 'vue';
import ProjectPickerModal from '../../components/ProjectPickerModal.vue';

document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.open-project-picker[data-config]');
    if (buttons.length === 0) {
        return;
    }

    const el = document.createElement('div');
    document.body.appendChild(el);
    createApp(ProjectPickerModal).mount(el);

    for (const button of buttons) {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            window.openProjectPickerModal(JSON.parse(button.dataset.config));
        });
    }
});
